import {
  fetchToolData,
  createDoc,
  updateDoc,
  deleteDoc,
  checkToolExists,
  updateTool,
} from './toolRepo';

import {
  createOrgDoc,
  updateOrgDoc,
  deleteOrgDoc,
} from './orgRepo';

import { unifiedLogin, checkOrgExists } from './userRepo';

import {
  CREATE_DOC_MESSAGE,
  DELETE_DOC_MESSAGE,
  UPDATE_DOC_MESSAGE,
  CREATE_ORGDOC_MESSAGE,
  DELETE_ORGDOC_MESSAGE,
  UPDATE_ORGDOC_MESSAGE,
  LOAD_TOOL_MESSAGE,
  SIGNUP_MESSAGE,
  LOGIN_MESSAGE,
  CHECK_TOOL_EXISTS_MESSAGE,
  CHECK_ORG_EXISTS_MESSAGE,
  UPDATE_TOOL_MESSAGE,
} from '../lib/MessageTypes';

import SentryClient from '../lib/SentryClient';

export const RepoListener = (request, sender, sendResponse) => {
  if (request.msgId === SIGNUP_MESSAGE) {
    unifiedLogin(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }

  if (request.msgId === LOGIN_MESSAGE) {
    unifiedLogin(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }
  
  if (request.msgId === CHECK_ORG_EXISTS_MESSAGE) {
    checkOrgExists(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }

  if (request.msgId === LOAD_TOOL_MESSAGE) {
    fetchToolData(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }

  if (request.msgId === UPDATE_TOOL_MESSAGE) {
    updateTool(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }

  if (request.msgId === CREATE_DOC_MESSAGE) {
    createDoc(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }

  if (request.msgId === UPDATE_DOC_MESSAGE) {
    updateDoc(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }

  if (request.msgId === DELETE_DOC_MESSAGE) {
    deleteDoc(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }

    if (request.msgId === CREATE_ORGDOC_MESSAGE) {
    createOrgDoc(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }

  if (request.msgId === UPDATE_ORGDOC_MESSAGE) {
    updateOrgDoc(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }

  if (request.msgId === DELETE_ORGDOC_MESSAGE) {
    deleteOrgDoc(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }

  if (request.msgId === CHECK_TOOL_EXISTS_MESSAGE) {
    checkToolExists(request, sender)
      .then((res) => {
        sendResponse(res);
      })
      .catch(handleFetchError(sendResponse));
    return true;
  }
};

const startRepoListeners = () => {
  chrome.runtime.onMessage.addListener(RepoListener);
};

const handleFetchError = (sendResponse) => (error) => {
  SentryClient.captureException(error);
  sendResponse({
    ok: false,
    status: 500,
    reason: 'An Unknown Error Occured',
  });
};

export default startRepoListeners;
